export default __webpack_public_path__ + "static/logo-c909e8c66181e5d6ab65b4fd2bde2b2c.jpg";